module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.openInformationPopup === true) ? _c('div', {
    staticClass: "modal",
    class: {
      visible: _vm.openInformationPopup
    }
  }, [_c('div', {
    staticClass: "frame visible",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/forest-background.png')"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.popupTitle))]), _vm._v(" "), _c('div', {
    staticClass: "popupDescription",
    domProps: {
      "innerHTML": _vm._s(_vm.popupDescription)
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cfd3bf9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/InformationPopup.vue
// module id = 765
// module chunks = 0